import linkifyHtml from 'linkify-html';
import { Decimal } from 'decimal.js-light';
import cloneDeep from 'lodash/cloneDeep';
import pako from 'pako';
import $f_announcements from '../announcements/announcements';
import $f_dashboard from '../dashboard/dashboard';
import mobile_translations from '../i18n-translations';
import $f_mobile, { $f_window } from '../mobile';
import $f_sensors from '../sensors/sensors';
import $f_storage from './storage';
import * as $f_sso_utils from '../shared/sso';
import $f_comments_utils from '../shared/comments/utils';
import $f, { global_formula_utils, global_recurring_utils, global_utils } from '../shared/forms';
import $f_sensors_utils from '../shared/sensors/util';
import $f_tasks from '../tasks/tasks';
import bluetooth from './bluetooth';
import localization from './localization';
import { isAndroid, isConnected, isIos, isNative, isWindows } from '../../shared/utils/is';
import { DeploymentFlagProvider } from '../../shared/deploymentFlags';
import Moment from 'moment-timezone';

/**
 * Attach ES module objects (noteably utils) to the window so they can be accessed by legacy JS code.
 *
 * // @todo:es6 this is meant to be temporary as we migrate further towards ES modules.
 *
 * @param {window} win The DOM window to attach objects to
 */
const attachModulesToWindow = (win) => {
    win.pako = pako;
    win.linkifyHtml = linkifyHtml;
    window.Decimal = Decimal;
    window.cloneDeep = cloneDeep;
    window.moment = Moment;

    win.$f = $f;
    win.$f.i18n = mobile_translations;
    win.$f.utils = global_utils;
    win.$f.utils.formula = global_formula_utils;
    win.$f.utils.recurring = global_recurring_utils;

    win.$f.utils.sso = $f_sso_utils;
    win.$f.window = $f_window;
    win.$f.mobile = $f_mobile;
    win.$f.flags = DeploymentFlagProvider;
    win.$f.mobile.bluetooth = bluetooth;
    win.$f.mobile.is = {
        native: isNative,

        connected: isConnected,

        ios: isIos,

        windows: isWindows,

        android: isAndroid
    };
    win.$f.mobile.localization = localization;
    win.$f.mobile.dashboard = $f_dashboard;
    win.$f.mobile.tasks = $f_tasks;
    win.$f.mobile.sensors = $f_sensors;
    win.$f.mobile.storage = $f_storage;
    win.$f.mobile.announcements = $f_announcements;
    win.$f.shared.comments.utils = $f_comments_utils;
    win.$f.shared.sensors.util = $f_sensors_utils;
};

export default attachModulesToWindow;
